// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import linkTypeEntity from './entities/link-type.json';
import linkTypeMenu from '../pages/link-type/menu.json';
import linkTypeFullForm from '../pages/link-type/forms/full.json';
import linkTypeContextForm from '../pages/link-type/forms/context.json';
import linkTypeMiniForm from '../pages/link-type/forms/mini.json';
import linkTypeLookupForm from '../pages/link-type/forms/lookup.json';
import linkTypeTableView from '../pages/link-type/views/table.json';
import linkTypeDashboardView from '../pages/link-type/views/dashboard.json';

/** Тип запису «Тип зв’язку» зі сторінками пакета: меню, форми та подання з pages/link-type/. */
export const linkTypeDefinition: IRecordTypeDefinition = {
  ...linkTypeEntity,
  views: assembleViewSet({
      table: linkTypeTableView,
      dashboard: linkTypeDashboardView,
  }),
  form: linkTypeFullForm,
  forms: { full: linkTypeFullForm, context: linkTypeContextForm, mini: linkTypeMiniForm, lookup: linkTypeLookupForm },
  menu: linkTypeMenu,
} as IRecordTypeDefinition;
